/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DOWNLOAD_IMAGE: 'Δεν ήταν δυνατή η λήψη της εικόνας',
    ERROR: 'Σφάλμα'
  },
  HEADER: {
    DESCRIPTION: 'Περιγραφή',
    END_DATE: 'Μέχρι το',
    ID: 'Id',
    START_DATE: 'Από το',
    TITLE: 'Τίτλος'
  },
  LABEL: {
    ACTIVES: 'Ενεργές εκστρατείες',
    CAMPAIGNS_SIGN_OR: 'Ή',
    CAMPAIGNS_SIGN_PLUS: '+',
    COUPON: 'Κουπόνι',
    DESCRIPTION: 'Περιγραφή',
    DESIGN_REQUESTS: 'Αιτήσεις σχεδιασμού',
    DESIGN_REQUESTS_ACTIVES: 'Εν ενεργεία αιτήσεις σχεδιασμού',
    DESIGN_REQUESTS_TERMINATED: 'Ολοκληρωμένες παραγγελίες σχεδιασμού',
    DETAIL: 'Λεπτομέρειες',
    END_DATE: 'Μέχρι το',
    FILES_TITLE: 'Πόροι εκστρατείας',
    FILES_TITLE_DESIGN_REQUEST: 'Πόροι για την αίτηση σχεδιασμού',
    FINISHED: 'Τελειωμένο',
    FINISHED_DESIGN_REQUEST: 'Τελειωμένο',
    GENERATED: 'Δημιουργήθηκε',
    GENERIC_DESIGN: 'Genikós schediasmós',
    ID: 'Id',
    IN_PROGRESS: 'Σε εξέλιξη',
    NO_ROWS_CAMPAIGNS: 'Δεν υπάρχουν καμπάνιες',
    NO_ROWS_DESIGN_REQUESTS: 'Χωρίς αιτήματα σχεδιασμού',
    OFFER: 'Προσφορά',
    PREVIOUS_LEVEL: 'Προηγούμενο επίπεδο',
    START_DATE: 'Από το',
    STATUS: 'Κράτος',
    TERMINATED: 'Τελειωμένες καμπάνιες',
    TITLE: 'Τίτλος',
    VALUE: 'Αξία'
  },
  SENTENCE: {
    ATTACHMENT_DESCRIPTION:
      'Δεν υπάρχουν συνημμένα για αυτή την καμπάνια (ακόμα).',
    ATTACHMENT_DESCRIPTION_DESIGN_REQUEST:
      'Δεν υπάρχουν συνημμένα για αυτή την αίτηση σχεδιασμού (ακόμα).',
    ATTACHMENT_TITLE: 'Δεν υπάρχουν συνημμένα'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
